import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

function Education() {
    return (
        <>
        <div id='Eduction'>
            <VerticalTimeline>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
                    date="2023"
                    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}>
                    <h3 className="vertical-timeline-element-title">Web Developer</h3>
                    <h4 className="vertical-timeline-element-subtitle">5Tech G PVT LTD</h4>
                    <p>
                        Full Stack Web Application (React,PHP,Python) - 2023 Present
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date="2022"
                    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}>
                    <h3 className="vertical-timeline-element-title">Jr. Data Scientist</h3>
                    <h4 className="vertical-timeline-element-subtitle">LetsGrowMore PVT LTD </h4>
                    <p>
                        Brain Stroke Prediction & Terririsim Data Analysis 🔨 (Aug 2022)
                   </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date="2022"
                    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}>
                    <h3 className="vertical-timeline-element-title">Jr Web Developer</h3>
                    <h4 className="vertical-timeline-element-subtitle">OrionSoft Tech Services PVT LTD</h4>
                    <p>
                        Clothing Shop Web Application 🥻 (May 2022)
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date="2019 - 2023"
                    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}>
                    <h3 className="vertical-timeline-element-title">ADCET Computer Science Engineering </h3>
                    <h4 className="vertical-timeline-element-subtitle">(2019-2023) BTech 💻</h4>
                    <p>
                        Computer Science Engineering 81% (8.1 CGPA)
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--education"
                    date="May 2019"
                    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}>
                    <h3 className="vertical-timeline-element-title">S.D. Gadre JR College Chiplun</h3>
                    <h4 className="vertical-timeline-element-subtitle">HSC 12th (2019) 🎓 </h4>
                    <p>
                        Maharashtra State Board Of Higher Secondary School 75%
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--education"
                    date="Jun 2017"
                    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}>
                   <h3 className="vertical-timeline-element-title">United English School Chiplun</h3>
                    <h4 className="vertical-timeline-element-subtitle">SSC 10th (2017) 🎓 </h4>
                    <p>
                        Maharashtra State Board Of Secondary School 91%
                    </p>
                </VerticalTimelineElement>
              
            </VerticalTimeline>
        </div>
        </>
    )
}

export default Education;